module.exports = __webpack_public_path__ + "img/desktop.1034214c.png";